import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
const Planning = lazy(() => import("@/pages/Planning"));
const Today = lazy(() => import("@/pages/Today"));
const Projects = lazy(() => import("@/pages/Projects"));
const Account = lazy(() => import("@/pages/Account"));
const ForgotPassword = lazy(() => import("@/pages/ForgotPassword"));
const ResetPassword = lazy(() => import("@/pages/ResetPassword"));
import "@/App.css";

const Spinner = () => (
  <div className="min-h-screen grid place-items-center bg-slate-50">
    <Loader2 className="h-7 w-7 animate-spin text-[#E8490F]" />
  </div>
);

function Gate({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function LoginGate() {
  const { user, loading } = useAuth();
  if (loading) return <Spinner />;
  if (user) return <Navigate to={user.role === "planner" ? "/planning" : "/vandaag"} replace />;
  return <Login />;
}

function Landing() {
  const { user, loading } = useAuth();
  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "planner" ? "/planning" : "/vandaag"} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Suspense fallback={<Spinner />}>
        <Routes>
          <Route path="/login" element={<LoginGate />} />
          <Route path="/wachtwoord-vergeten" element={<ForgotPassword />} />
          <Route path="/wachtwoord-herstellen" element={<ResetPassword />} />
          <Route path="/account" element={<Gate><Account /></Gate>} />
          <Route path="/" element={<Landing />} />
          <Route path="/vandaag" element={<Gate><Today /></Gate>} />
          <Route path="/planning" element={<Gate><Planning /></Gate>} />
          <Route path="/projecten" element={<Gate><Projects /></Gate>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}
